import $ from 'jquery'

/*
 * Note: office_visibility is from a 3rd party vendor.
 * it was in use for years within web_presenter, and before that, agave repo
 * in porting it to singularity it was taken in it's entirety as
 * it is unknown if this code's functionality changes between environments
 *
 * It is possible to do away with it - but before doing so, officially, we
 * will want to test with the office store in a few places:
 * 1) within chrome powerpoint office 365
 * 2) within safari powerpoint office 365
 * 3) within desktop powerpoint app macos office 365 store
 * 4) within desktop pweorpoint app windows office 365 store
 *
 * If we want to do away with this file, we'll need to replicate
 * functionality for onVisibilityChange within the office_events file
 * and re-test on all platforms.
 */

export default function (reason, isPresentingFunc) {
  var self = this

  self.onAppSlide = false

  var OM = window.Office.context.document

  var appSlideData = { slideId: null, confidenceLevel: 0 }

  var ConfidenceLevel = {
    Low: 0,
    Medium: 1,
    High: 2
  }

  var updateSlideData = function (slideId, confidenceLevel) {
    if (appSlideData.confidenceLevel >= confidenceLevel) {
      return
    }
    appSlideData.slideId = slideId
    appSlideData.confidenceLevel = confidenceLevel
    OM.settings.set('appSlideData', appSlideData)
    OM.settings.saveAsync()
  }

  var getAndUpdateSlideData = function (confidenceLevel) {
    OM.getSelectedDataAsync(window.Office.CoercionType.SlideRange, function (asyncResult) {
      if (asyncResult.status === 'failed') {
        throw asyncResult.error.message
      } else {
        if (asyncResult.value.slides.count > 1) {
          confidenceLevel = ConfidenceLevel.Low
        }
        updateSlideData(asyncResult.value.slides[0].id, confidenceLevel)
      }
    })
  }

  $(window).bind('click keydown', function () {
    var confidenceLevel = ConfidenceLevel.High
    if (confidenceLevel > appSlideData.confidenceLevel) {
      getAndUpdateSlideData(confidenceLevel)
    }
  })

  self.onVisibilityChange = function (visibilityChangedCallback) {
    var insideAgave = false
    var currentStateSameSlide = false
    var initialSlideCheckPerformed = false

    // need to poll the host to see what the current slide is as no event is exposed for changing slides
    $(window).bind('mousemove focus', function () {
      insideAgave = true
    })
    $(window).bind('mouseleave blur', function () {
      insideAgave = false
    })
    window.setInterval(function () {
      if (isPresentingFunc()) {
        if ((!insideAgave || !currentStateSameSlide || !initialSlideCheckPerformed)) {
          OM.getSelectedDataAsync(window.Office.CoercionType.SlideRange, function (asyncResult) {
            if (asyncResult.status === 'succeeded') {
              // compare the current slide to what the app thinks its slide is, if different fire event
              currentStateSameSlide = (asyncResult.value.slides[0].id === appSlideData.slideId)
              if (self.onAppSlide !== currentStateSameSlide || !initialSlideCheckPerformed) {
                initialSlideCheckPerformed = true
                self.onAppSlide = currentStateSameSlide
                visibilityChangedCallback({ visible: currentStateSameSlide })
              }
            }
          })
        }
      } else {
        initialSlideCheckPerformed = false
      }
    }, 2000)
  }

  $(function () {
    var storedData = OM.settings.get('appSlideData')
    if (storedData != null) {
      appSlideData = storedData
    }
    if (reason === 'inserted') {
      getAndUpdateSlideData(ConfidenceLevel.Medium)
    }
  })
}
